var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItCompeteIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "itCompeteIco_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0.6)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0.6)",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.578%",
    y1: "32.033%",
    x2: "75.493%",
    y2: "64.872%",
    id: "itCompeteIco_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0.6)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0.6)",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.48 1.386a12.006 12.006 0 00-.93 2.186c-.685 2.19-.765 4.653-.04 7.186 1.085 3.793 4.027 6.796 7.788 7.924 3.887 1.165 7.61.398 10.45-1.57a1.12 1.12 0 00.187-1.679l-.883-.953-1.416-1.53a1.107 1.107 0 00-1.296-.242c-2.506 1.206-5.172.798-5.172.798-4.762-.881-8.37-5.077-8.37-10.122 0-1.093.173-2.144.487-3.131.027-.085.053-.17.082-.253-.326.44-.622.903-.887 1.386",
    id: "itCompeteIco_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.327 0C3.724.023 0 3.444 0 7.921a7.924 7.924 0 00.956 3.772l.008.015a8.219 8.219 0 001.282 1.754l-.045-.148a6.081 6.081 0 01-.338-2.673c.295-2.996 2.805-5.175 5.895-5.4 1.402-.102 2.774.158 3.917.748a1.118 1.118 0 001.342-.235l1.29-1.438.81-.903a1.043 1.043 0 00-.233-1.587C13.014.649 10.758.016 8.327 0z",
    id: "itCompeteIco_svg__d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.77)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "itCompeteIco_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#itCompeteIco_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.48 1.386a12.006 12.006 0 00-.93 2.186c-.685 2.19-.765 4.653-.04 7.186 1.085 3.793 4.027 6.796 7.788 7.924 3.887 1.165 7.61.398 10.45-1.57a1.12 1.12 0 00.187-1.679l-.883-.953-1.416-1.53a1.107 1.107 0 00-1.296-.242c-2.506 1.206-5.172.798-5.172.798-4.762-.881-8.37-5.077-8.37-10.122 0-1.093.173-2.144.487-3.131.027-.085.053-.17.082-.253-.326.44-.622.903-.887 1.386",
    fill: "url(#itCompeteIco_svg__b)",
    mask: "url(#itCompeteIco_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "itCompeteIco_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#itCompeteIco_svg__d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.327 0C3.724.023 0 3.444 0 7.921a7.924 7.924 0 00.956 3.772l.008.015a8.219 8.219 0 001.282 1.754l-.045-.148a6.081 6.081 0 01-.338-2.673c.295-2.996 2.805-5.175 5.895-5.4 1.402-.102 2.774.158 3.917.748a1.118 1.118 0 001.342-.235l1.29-1.438.81-.903a1.043 1.043 0 00-.233-1.587C13.014.649 10.758.016 8.327 0z",
    fill: "url(#itCompeteIco_svg__e)",
    mask: "url(#itCompeteIco_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.849 9.615h1.69l-1.195 5.77h-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.46 10.91h-1.883l.28-1.295h5.49l-.281 1.294h-1.873l-.955 4.476h-1.733z"
  }))));
}
export default SvgItCompeteIco;